import { Maybe } from '@ats/api/cm';
import { AtsUtility } from '../classes/ats-utility.class';

export const notNullOrUndefined: <T = any>(item: Maybe<T> | T | undefined | null) => item is T =
	AtsUtility.isNotNullOrUndefined;
